import { ITermSession } from '../../../interfaces/scheduler_interfaces';
import { ICrossCourseCorequisitesDatasource } from '../../../components/section_corequisite/datasources/cross_course_corequisite_datasource';
import { LinkedSectionsModel } from '../../sections/models/linked_sections_model';
import { ISectionAvailabilityDatasource } from '../../sections/datasources/section_availability_datasource';
import { RegistrationWaitlistPositionModel } from '../../course_scheduler/models/registration_waitlist_position_model';
import { IWaitlistStatusDatasource } from '../../course_scheduler/datasources/waitlist_status_datasource';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { ISectionTimesDatasource } from '../../sections/datasources/section_times_datasource';
import { ILocationsDatasource } from '../../sections/datasources/locations_datasource';
import { ICampusesDatasource } from '../../sections/datasources/campuses_datasource';
import { SchedulerModel } from '../../course_scheduler/models/scheduler_model';
import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { SelectedUnscheduledSectionModel } from '../../unscheduled_sections/models/selected_unscheduled_section_model';
import { ISectionLabelsDatasource } from '../../sections/datasources/section_labels_datasource';
import { LoadCrossCourseLinkedSectionsFacade } from '../../sections/facades/load_cross_course_linked_sections_facade';

interface IWaitListPosition {
  id: number;
  nk: string;
  section: number;
  position: number;
  place_in_waitlist: number;
}

export type GetTermSectionsCommand = (termId: ITermSession['term']) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'getTermSectionsCommand',
    (
      $http: ng.IHttpService,
      $q: ng.IQService,
      defineCommandORM: IDefineCommand,
      ngCampusesDatasource: ICampusesDatasource,
      ngLocationsDatasource: ILocationsDatasource,
      ngSectionTimesDatasource: ISectionTimesDatasource,
      ngSectionsDatasource: ISectionsDatasource,
      ngSchedulerModel: SchedulerModel,
      ngRegistrationWaitlistPositionModel: RegistrationWaitlistPositionModel,
      ngWaitlistStatusDatasource: IWaitlistStatusDatasource,
      ngSectionAvailabilityDatasource: ISectionAvailabilityDatasource,
      ngLinkedSectionsModel: LinkedSectionsModel,
      ngSectionLabelsDatasource: ISectionLabelsDatasource,
      ngSelectedUnscheduledSectionModel: SelectedUnscheduledSectionModel,
      ngCrossCourseCorequisitesDatasource: ICrossCourseCorequisitesDatasource,
      ngLoadCrossCourseLinkedSectionsFacade: LoadCrossCourseLinkedSectionsFacade,
      log: any
    ): ICommand => {
      return defineCommandORM('getTermSectionsCommand', (deferred, termId: ITermSession['term']) => {
        $q.all({
          schedule: $http({
            method: 'GET',
            url: `reg/course_schedule/term/${termId}/`
          })
        })

          .then((responses: Record<string, ng.IHttpPromiseCallbackArg<any>>) => {
            // Clear all supporting datasources on load.

            // TODO refactor ngSectionAvailabilityDatasource, ngWaitlistStatusDatasource.  Are they now the same?
            ngSectionAvailabilityDatasource.clear().write(_4.get(responses, 'schedule.data.section_status', {}));
            ngSelectedUnscheduledSectionModel.clear();
            ngCampusesDatasource.write(_4.get(responses, 'schedule.data.campus', {}));

            ngSectionLabelsDatasource.write(_4.get(responses, 'schedule.data.section_labels'));

            ngLocationsDatasource.clear().write(_4.get(responses, 'schedule.data.location', {}));
            ngLinkedSectionsModel.clear().write(_4.get(responses, 'schedule.data.section_link', {}));
            ngSectionTimesDatasource.clear().write(_4.get(responses, 'schedule.data.section_time', {}));
            ngWaitlistStatusDatasource.clear().write(_4.get(responses, 'schedule.data.section_status', {}));
            ngSchedulerModel.write({
              channel_name: responses.schedule.data.channel_name,
              in_state_credit_cost: responses.schedule.data.in_state_credit_cost
            });
            ngSectionsDatasource.clear().write(_4.get(responses, 'schedule.data.section', {}));
            ngCrossCourseCorequisitesDatasource.clear();

            const missingSections = ngLoadCrossCourseLinkedSectionsFacade.loadCrossCourseLinkedSections(
              ngLinkedSectionsModel.read()
            );
            const waitlistPositions: Record<string, IWaitListPosition> = _4.get(
              responses,
              'schedule.data.waitlist_position',
              {}
            );
            ngRegistrationWaitlistPositionModel.clear();
            _4.each(waitlistPositions, (position) => {
              ngRegistrationWaitlistPositionModel.put({
                place_in_waitlist: position.place_in_waitlist,
                waitlist_position: position.position,
                section: position.section
              });
            });
            return $q.all([...missingSections]).then(() => {
              deferred.resolve();
            });
          })
          .catch((e) => {
            log.issue('Failed to get courses for this term');
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/commands/get_term_sections_command.ts